import React from 'react'
import White from '../white'
import MaxWidth from '../maxwidth'
import styled from 'styled-components'

const Box = styled.div`
  width: 100%;
  border: 2px solid #000;
  border-radius: 41px;
  padding: 70px 20px;
  text-align: center;
  margin-top: 130px;
  @media(max-width: 768px) {
    margin-top: 60px;
  }
  h1 {
    font-family: Oswald, sans-serif !important;
    text-transform: uppercase;
    font-weight: 300;
  }
  h3 {
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 20px;
  }
  p {
    margin-bottom: 60px;
  }
  hr {
    margin-bottom: 67px;
  }
`

const Table = styled.div`
  margin-top: 67px;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  &:first-of-type {
    margin-bottom: 83px;
  }
  div {
    width: 100;
    display: flex;
    span {
      display: block;
      width: 100%;
      text-align: left;
    }
  }
`

const Row = styled.div`
  width: 100%;
  padding-top: 8px;
  padding-bottom: 8px;
  div {
    width: 100%;
    max-width: 850px;
    display: flex;
    margin: 0 auto;
    font-size: 22px;
    line-height: 32px;
    @media(max-width: 768px) {
      font-size: 18px;
      line-height: 28px; 
    }
    &.heading {
      font-weight: 500;
    }
  }
  &.even {
    background-color: #f0f0f0;
  }
`


const Race = ({ key, module }) => {

  return (
    <White>
      <MaxWidth>
        <Box>
          <h3>{module.title}</h3>
          <p>{module.details}</p>
          <hr />
          <h3>MEN'S CHAMPION</h3>
          <h1>{module.mens_champion}</h1>
          <Table>
            <Row><div className="heading"><span>STAGE</span><span>TIME</span><span>TOTAL</span></div></Row>
            {module.mens_stages.map((s, index) => {
              return (
                <Row className={index % 2 === 0 ? 'even' : 'odd'}><div><span>{s.title}</span><span>{s.time}</span><span>{s.total}</span></div></Row>
              )
            })}
          </Table>

          <h3>WOMEN'S CHAMPION</h3>
          <h1>{module.womens_champion}</h1>
          <Table>
            <Row><div className="heading"><span>STAGE</span><span>TIME</span><span>TOTAL</span></div></Row>
            {module.womens_stages.map((s, index) => {
              return (
                <Row className={index % 2 === 0 ? 'even' : 'odd'}><div><span>{s.title}</span><span>{s.time}</span><span>{s.total}</span></div></Row>
              )
            })}
          </Table>

        </Box>
      </MaxWidth>
    </White>
  )
}

export default Race
